/* LMGF master brand template: sort, filter, add to cart, quick view, flavor tabs, mobile shop bar. No dependencies. */
(function () {
  var root = document.querySelector('.lm-brand');
  if (!root) return;
  var fixed = document.querySelector('.lm-fixed');
  var money = function (cents) {
    var f = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: f }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- toast + cart ---------- */
  var toast = fixed && fixed.querySelector('[data-toast]');
  var toastTimer;
  function showToast(title, img) {
    if (!toast) return;
    toast.querySelector('[data-toast-title]').textContent = title + ' added';
    var im = toast.querySelector('[data-toast-img]');
    if (img) { im.src = img; im.hidden = false; } else { im.hidden = true; }
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 3800);
  }
  function refreshCartBubble() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var el = document.getElementById('cart-icon-bubble');
        if (el && s['cart-icon-bubble']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = s['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section') || tmp;
          el.innerHTML = inner.innerHTML;
        }
      }).catch(function () {});
  }
  function addToCart(id, qty, btn, title, img) {
    if (btn) { btn.disabled = true; }
    return fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (btn) { btn.disabled = false; }
      if (res.status) { alert(res.description || res.message); return; }
      if (btn) { var t = btn.textContent; btn.classList.add('done'); btn.textContent = 'Added'; setTimeout(function () { btn.classList.remove('done'); btn.textContent = t; }, 1600); }
      showToast(title, img);
      refreshCartBubble();
      document.dispatchEvent(new CustomEvent('lmgf:cart-updated'));
    }).catch(function () { if (btn) btn.disabled = false; });
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b) return;
    e.preventDefault();
    addToCart(b.getAttribute('data-add'), 1, b, b.getAttribute('data-title'), b.getAttribute('data-img'));
  });

  /* ---------- sort + segment filter ---------- */
  var grid = root.querySelector('[data-grid]');
  var sortBtn = root.querySelector('[data-sort-btn]');
  var menu = root.querySelector('.sortmenu');
  if (sortBtn && menu && grid) {
    sortBtn.addEventListener('click', function () {
      var open = menu.hidden;
      menu.hidden = !open;
      sortBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.sortwrap')) { menu.hidden = true; sortBtn.setAttribute('aria-expanded', 'false'); } });
    menu.addEventListener('click', function (e) {
      var o = e.target.closest('[data-sort]');
      if (!o) return;
      var key = o.getAttribute('data-sort');
      menu.querySelectorAll('[data-sort]').forEach(function (x) { x.classList.toggle('on', x === o); x.setAttribute('aria-selected', x === o ? 'true' : 'false'); });
      root.querySelector('[data-sort-label]').textContent = o.textContent;
      var cards = Array.prototype.slice.call(grid.children);
      cards.sort(function (a, b) {
        var A = a.dataset, B = b.dataset;
        if (key === 'rating') return (+B.rating) - (+A.rating);
        if (key === 'price-asc') return (+A.price) - (+B.price);
        if (key === 'price-desc') return (+B.price) - (+A.price);
        if (key === 'title') return A.title.localeCompare(B.title);
        return (+A.idx) - (+B.idx);
      });
      cards.forEach(function (c) { grid.appendChild(c); });
      menu.hidden = true; sortBtn.setAttribute('aria-expanded', 'false');
    });
  }
  root.querySelectorAll('[data-seg]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var t = chip.getAttribute('data-seg'), n = 0;
      root.querySelectorAll('[data-seg]').forEach(function (c) { c.classList.toggle('on', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      grid.querySelectorAll('.card').forEach(function (c) { var show = !t || c.dataset.type === t; c.hidden = !show; if (show) n++; });
      var cnt = root.querySelector('[data-count]'); if (cnt) cnt.textContent = n;
    });
  });

  /* ---------- flavor tabs ---------- */
  root.querySelectorAll('[data-tabs] [role=tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var wrap = tab.closest('[data-tabs]');
      wrap.querySelectorAll('[role=tab]').forEach(function (t) { var on = t === tab; t.classList.toggle('on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      wrap.querySelectorAll('[role=tabpanel]').forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
    });
  });

  /* ---------- quick view ---------- */
  var qvo = fixed && fixed.querySelector('[data-qvo]');
  var qv = { variant: null, qty: 1, title: '', img: '' }, lastFocus;
  function closeQV() { if (!qvo) return; qvo.hidden = true; document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qv]');
    if (!b || !qvo) return;
    e.preventDefault();
    lastFocus = b;
    fetch('/products/' + b.getAttribute('data-qv') + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
      qv.variant = v; qv.qty = 1; qv.title = p.title;
      qv.img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=900' : '';
      qvo.querySelector('[data-qv-img]').src = qv.img;
      qvo.querySelector('[data-qv-img]').alt = p.title;
      qvo.querySelector('[data-qv-title]').textContent = p.title;
      var tmp = document.createElement('div'); tmp.innerHTML = p.description || '';
      var d = (tmp.textContent || '').trim();
      qvo.querySelector('[data-qv-desc]').textContent = d.length > 180 ? d.slice(0, 177) + '…' : d;
      qvo.querySelector('[data-qv-price]').textContent = money(v.price);
      qvo.querySelector('[data-qty-val]').textContent = '1';
      qvo.querySelectorAll('[data-qv-link]').forEach(function (a) { a.href = p.url || ('/products/' + p.handle); });
      var add = qvo.querySelector('[data-qv-add]');
      add.disabled = !v.available;
      add.textContent = v.available ? (p.variants.length > 1 ? 'Add ' + v.title : 'Add to cart') : 'Sold out';
      qvo.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      qvo.querySelector('[data-qx]').focus();
    });
  });
  if (qvo) {
    qvo.addEventListener('click', function (e) { if (e.target === qvo || e.target.closest('[data-qx]')) closeQV(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !qvo.hidden) closeQV(); });
    qvo.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () { qv.qty = Math.max(1, qv.qty + Number(b.getAttribute('data-qty'))); qvo.querySelector('[data-qty-val]').textContent = qv.qty; });
    });
    qvo.querySelector('[data-qv-add]').addEventListener('click', function (e) {
      if (!qv.variant) return;
      addToCart(qv.variant.id, qv.qty, e.currentTarget, qv.title, qv.img).then(closeQV);
    });
  }

  /* ---------- mobile shop bar: show after the hero, hide over the product grid ---------- */
  var bar = fixed && fixed.querySelector('[data-shopbar]');
  var hero = root.querySelector('.bhero'), allp = root.querySelector('[data-allp]');
  if (bar && hero && allp && 'IntersectionObserver' in window) {
    var heroIn = true, allIn = false;
    var set = function () { var on = !heroIn && !allIn; bar.classList.toggle('off', !on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); bar.querySelector('a').tabIndex = on ? 0 : -1; };
    new IntersectionObserver(function (es) { heroIn = es[0].isIntersecting; set(); }).observe(hero);
    new IntersectionObserver(function (es) { allIn = es[0].isIntersecting; set(); }).observe(allp);
  }
})();
